import { type Reducer } from "react";
import { type VendorDataItem } from "../gql-generated";
import { VendorDataCollection, VendorDataEntryModel } from "./models";

export type VendorDataChangedAction =
    | {
          type: "add";
      }
    | {
          type: "remove";
          entry: VendorDataEntryModel;
      }
    | { type: "update"; entry: VendorDataEntryModel }
    | { type: "replace"; entries: readonly VendorDataItem[] };

export const vendorDataReducer: Reducer<VendorDataCollection, VendorDataChangedAction> = (state, action) => {
    switch (action.type) {
        case "add":
            return state.addEmptyVendorData();
        case "remove":
            return state.removeVendorData(action.entry.index as number);
        case "update":
            return state.updateVendorData(action.entry);
        case "replace":
            return state.replaceVendorData(action.entries);
        default:
            return state;
    }
};
